export function animations() {
    const text = document.getElementsByClassName("text-animation");
    const line = document.getElementsByClassName("line-animation");
    const image = document.getElementsByClassName("image-animation")


    document.addEventListener("scroll", () => {

        const clientHeight = document.documentElement.clientHeight;
        // console.log("clientHeight", clientHeight);

        // need to loop through text.length to apply these conditions to all nodes
        for (let i = 0; i < text.length; i++) {
            const textY = text[i].getBoundingClientRect().y;
            // console.log("textY", textY);
            const textHeight = text[i].getBoundingClientRect().height;
            // console.log("textHeight", textHeight);
            
            if (clientHeight > textY + (textHeight * 2) / 6) {
                text[i].style.animation = "opacityUp 1s forwards cubic-bezier(0.87, 0, 0.13, 1)";
                // console.log("text is in view!");
                // execute an animation here for the text that is now in view
            }
            if (clientHeight < textY) {
                text[i].style.animation = "opacityDown 1s forwards cubic-bezier(0.87, 0, 0.13, 1)";
                // console.log("text is hidden!");
                // either do nothing here and leave the text the way it is
                // OR revert the animation so when you scroll back up you get the animation again
            }
        }

        // loop for all of the lines
        for (let i = 0; i < line.length; i++) {
            const lineY = line[i].getBoundingClientRect().y;
            const lineHeight = line[i].getBoundingClientRect().height;

            if (clientHeight > lineY + (lineHeight * 2) / 6) {
                line[i].style.animation = "lineUp 1s forwards cubic-bezier(0.87, 0, 0.13, 1)";
            }
            if (clientHeight < lineY) {
                line[i].style.animation = "lineDown 1s forwards cubic-bezier(0.87, 0, 0.13, 1)";
            }
        }

        // Loop for all of the images
        for (let i = 0; i < image.length; i++) {
            const imageY = image[i].getBoundingClientRect().y;
            const imageHeight = image[i].getBoundingClientRect().height;
            if (clientHeight > imageY + (imageHeight * 2) / 10) {
                image[i].style.animation = "imageUp 1s forwards cubic-bezier(0.87, 0, 0.13, 1)";
            }
            if (clientHeight < imageY) {
                image[i].style.animation = "imageDown 1s forwards cubic-bezier(0.87, 0, 0.13, 1)";
            }
        }
    })
}
        
